import { ConversationChip } from 'components/conversation';

import { useConversationRow } from '../../../utils/useConversationRow';

/** Represents the content of the csid cell in the conversations table. */
export const ConversationsTableCsid = (): JSX.Element => {
  const { conversation } = useConversationRow();

  return (
    <ConversationChip
      csid={conversation.id}
      channel={conversation.initial_channel}
      status={conversation.status}
    />
  );
};
